import { reactive } from '@nuxtjs/composition-api';

const globalRefs = reactive({}) as Record<string, any>;

export  function useGlobalRefs() {
    return globalRefs;
}
